export default {
  // HTwbCardHome.vue 字串
  title: "HTcard",
  login: "登入",
  logout: "登出",
  
  // 搜尋相關
  searchPlaceholder: "搜尋收集板標題...",
  clearSearch: "清除搜尋",
  searching: "搜尋中...",
  searchResults: "找到 {count} 個結果",
  
  // 收集板相關
  addCollectBoard: "新增收集板\n(CardCollect)",
  collectBoardStatus: {
    openSubmit: "開放提交",
    closeSubmit: "關閉提交"
  },
  
  // 未登入狀態
  welcome: {
    title: "歡迎使用 HTcard",
    message: "請先登入以開始使用卡片收集功能"
  },
  
  // Modal 標題
  modals: {
    createTitle: "新增收集板",
    editTitle: "更新收集板設定",
    deleteTitle: "確認刪除收集板"
  },
  
  // 表單
  forms: {
    collectBoardName: "請輸入收集板名稱",
    openSubmitLabel: "開放提交",
    cancel: "取消",
    create: "建立",
    update: "更新",
    delete: "刪除",
    setting: "設定"
  },
  
  // 刪除確認
  deleteConfirm: {
    message: "確定要刪除收集板「{name}」嗎？",
    warning: "警告：此操作將會刪除收集板內的所有卡片及其檔案，無法復原，請謹慎確認！",
    deleting: "刪除中...",
    confirmDelete: "確認刪除"
  },
  
  // 訊息提示
  messages: {
    loginSuccess: "登入成功！",
    loginFailed: "登入失敗",
    logoutSuccess: "登出成功",
    logoutFailed: "登出失敗",
    loadFailed: "載入失敗",
    createSuccess: "建立成功！",
    createFailed: "建立失敗",
    updateSuccess: "更新成功！",
    updateFailed: "更新失敗",
    deleteSuccess: "收集板刪除成功！",
    deleteFailed: "刪除失敗，請稍後再試",
    searchFailed: "搜尋失敗，請稍後再試",
    alreadyCopied: "已複製到剪貼簿"
  },

  // HTwbCardCollect.vue 字串
  collect: {
    loading: "載入中...",
    loadFailed: "載入失敗",
    
    // 搜尋
    searchCardPlaceholder: "搜尋卡片名稱或創建者...",
    searchResultsCount: "找到 {count} 個結果",
    
    // 顏色篩選
    colorFilter: "顏色篩選",
    colorTitle: "色彩",
    clearFilter: "清除",
    colors: {
      white: "白色",
      lightYellow: "淺黃",
      lightGreen: "淺綠", 
      lightBlue: "淺藍",
      lightPink: "淺粉"
    },
    
    // 按鈕
    uploadCard: "上傳新卡片",
    addGroup: "新增分組",
    share: "共用",
    shareCard: "分享卡片收藏集",
    
    // 媒體播放錯誤
    videoNotSupported: "您的瀏覽器不支援影片播放",
    audioNotSupported: "您的瀏覽器不支援音訊播放",
    imageLoadFailed: "圖片載入失敗",
    
    // 上傳卡片 Modal
    uploadModal: {
      title: "上傳新卡片",
      cardName: "卡片名稱 *",
      cardNamePlaceholder: "請輸入卡片名稱",
      selectGroup: "選擇分組",
      textContent: "文字內容 (可選)",
      textContentPlaceholder: "在這裡輸入您的文字內容...",
      cardColor: "卡片顏色",
      selectFile: "選擇檔案 (可選)",
      dragDropFile: "點擊選擇檔案或拖拽檔案到此處",
      fileHint: "支援所有檔案格式",
      fileSizeHint: "檔案大小限制：{size}MB",
      removeFile: "移除檔案",
      uploading: "上傳中...",
      uploadCard: "上傳卡片",
      cancel: "取消"
    },
    
    // 編輯卡片 Modal
    editModal: {
      title: "編輯卡片",
      currentFile: "目前檔案：",
      replaceFile: "更換檔案",
      removeCurrentFile: "移除目前檔案",
      updating: "更新中...",
      confirmUpdate: "確認更新"
    },
    
    // 刪除卡片確認
    deleteCardConfirm: {
      title: "確認刪除",
      message: "確定要刪除卡片「{name}」嗎？",
      warning: "此操作無法復原，將會永久刪除卡片及其檔案。",
      deleting: "刪除中...",
      confirmDelete: "確認刪除",
      cancel: "取消"
    },
    
    // 新增分組 Modal
    addGroupModal: {
      title: "新增分組",
      groupName: "分組名稱 *",
      groupNamePlaceholder: "請輸入分組名稱",
      adding: "新增中...",
      confirmAdd: "確認新增",
      cancel: "取消"
    },
    
    // 卡片選單
    cardMenu: {
      edit: "編輯",
      delete: "刪除"
    },
    
    // 預設分組
    defaultGroup: "分組一",
    
    // 檔案類型
    fileTypes: {
      unknown: "未知檔案",
      image: "圖片",
      video: "影片", 
      audio: "音訊",
      word: "Word文件",
      pdf: "PDF文件",
      text: "文字檔",
      zip: "ZIP壓縮檔",
      rar: "RAR壓縮檔",
      general: "一般檔案",
      textFile: "文字檔案",
      applicationFile: "應用程式檔案"
    },
    
    // 上傳狀態
    uploadStatus: {
      preparing: "準備上傳...",
      creating: "正在建立卡片記錄...",
      uploading: "正在上傳檔案... ({uploaded}MB / {total}MB)",
      updating: "正在更新卡片資訊...",
      saving: "正在儲存文字卡片...",
      completed: "上傳完成！",
      textCardCreated: "文字卡片建立成功！",
      failed: "上傳失敗"
    },
    
    // 錯誤訊息
    errors: {
      cardNameRequired: "請輸入卡片名稱",
      cardNameTooLong: "卡片名稱不能超過50個字元",
      contentRequired: "請輸入文字內容或選擇檔案",
      textOrFileRequired: "請輸入文字內容或保留/選擇檔案",
      fileSizeExceeded: "檔案大小不能超過 {size}MB",
      groupNameRequired: "請輸入分組名稱",
      groupNameTooLong: "分組名稱不能超過20個字元",
      groupNameExists: "分組名稱已存在",
      missingUserInfo: "無法取得用戶資訊，請重新整理頁面",
      missingIdInfo: "缺少必要的 ID 資訊",
      sasTokenExpired: "SAS Token 已過期，請重新整理頁面",
      fileUploadFailed: "檔案上傳失敗，請檢查網路連線",
      updateDataError: "請求資料有誤: {error}",
      cardNotFound: "找不到要更新的卡片",
      noPermission: "沒有權限執行此操作",
      authFailed: "認證失敗，請重新整理頁面",
      networkError: "網路錯誤，請檢查連線",
      generalError: "操作失敗，請稍後再試",
      copyFailed: "複製失敗",
      updateFailed: "更新失敗"
    },
    
    // 成功訊息
    successMessages: {
      cardUploaded: "卡片上傳成功！",
      textCardCreated: "文字卡片建立成功！",
      cardUpdated: "卡片更新成功！",
      cardDeleted: "卡片刪除成功！", 
      cardMoved: "卡片已移動到新分組",
      groupAdded: "分組新增成功！",
      settingsUpdated: "設定已更新"
    },
    
    // 用戶身份
    userIdentity: {
      loggedInUser: "登入用戶",
      anonymousUser: "匿名用戶",
      systemUser: "系統"
    },
    
    // 留言相關
    comments: {
      placeholder: "輸入留言...",
      published: "留言已發布",
      updated: "留言已更新", 
      deleted: "留言已刪除",
      publishFailed: "發布留言失敗",
      updateFailed: "更新留言失敗",
      deleteFailed: "刪除留言失敗",
      edit: "編輯留言",
      delete: "刪除留言",
      justNow: "剛剛",
      minutesAgo: "{minutes}分鐘前",
      hoursAgo: "{hours}小時前",
      daysAgo: "{days}天前",
      // 編輯附件相關
      removeAttachment: "移除附件",
      addAttachment: "新增附件",
      replaceAttachment: "更換附件",
      contentRequired: "留言內容或附件不能為空",
      fileTooLarge: "檔案 {fileName} 過大（超過 5MB）",
      fileUploaded: "檔案 {fileName} 上傳成功",
      fileUploadFailed: "檔案 {fileName} 上傳失敗",
      fileProcessFailed: "檔案處理失敗",
      save: "儲存",
      cancel: "取消"
    }
  }
};